import React, {useState} from 'react';
import {AUTHENTICATED_ROUTES} from '../../../navigation/constants';
import ConfigurePackage from '../../ConfigurePackage';
import PackagePurchaseSummary from '../../PackagePurchaseSummary';
import Payment from '../../Payment';
import SelectTimeTable from '../../SelectTimeTable';

const SubscriptionLandscapeModalController = ({handleClose, params}) => {
  const initRoute = AUTHENTICATED_ROUTES.configurePackage.path;
  const [routeToRender, setRouteToRender] = useState(initRoute);
  const [routesParams, setRoutesParams] = useState({[initRoute]: params});

  const setRouteAndParams = (route, paramsToSet) => {
    setRouteToRender(route);
    if (paramsToSet) {
      setRoutesParams((prev) => ({...prev, [route]: paramsToSet}));
    }
  };

  switch (routeToRender) {
    case AUTHENTICATED_ROUTES.configurePackage.path:
      return (
        <ConfigurePackage
          landscapeParams={routesParams[routeToRender]}
          setLandscapeRouteAndParams={setRouteAndParams}
          handleCloseModal={handleClose}
        />
      );

    case AUTHENTICATED_ROUTES.selectTimeTable.path:
      return (
        <SelectTimeTable
          landscapeParams={routesParams[routeToRender]}
          setLandscapeRouteAndParams={setRouteAndParams}
        />
      );

    case AUTHENTICATED_ROUTES.packagePurchaseSummary.path:
      return (
        <PackagePurchaseSummary
          landscapeParams={routesParams[routeToRender]}
          setLandscapeRouteAndParams={setRouteAndParams}
        />
      );

    case AUTHENTICATED_ROUTES.payment.path:
      return (
        <Payment
          landscapeParams={routesParams[routeToRender]}
          onModalBackPressed={() => {
            setRouteAndParams(
              AUTHENTICATED_ROUTES.packagePurchaseSummary.path,
              undefined,
            );
          }}
          handleCloseModal={handleClose}
        />
      );

    default:
      return null;
  }
};

export default SubscriptionLandscapeModalController;
